var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0039 10.623C13.5566 10.623 14.8154 9.36424 14.8154 7.81149C14.8154 6.25875 13.5566 5 12.0039 5C10.4511 5 9.19238 6.25875 9.19238 7.81149C9.19238 9.36424 10.4511 10.623 12.0039 10.623Z",
    fill: "#B2022F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.967 17.1269C18.6754 15.7991 18.0067 14.5836 17.0412 13.6266C16.8068 13.3914 16.5529 13.1767 16.2821 12.9846C15.0488 12.0595 13.5455 11.5656 12.0039 11.5789C10.1189 11.5692 8.30647 12.3053 6.96196 13.6266C5.99645 14.5836 5.32773 15.7991 5.03609 17.1269C4.9854 17.3617 4.98814 17.6049 5.0441 17.8385C5.10007 18.0721 5.20783 18.2901 5.35941 18.4764C5.5164 18.6667 5.71409 18.8194 5.93791 18.9232C6.16174 19.027 6.406 19.0793 6.6527 19.0762H17.3551C17.6025 19.0763 17.8468 19.0208 18.0699 18.9138C18.293 18.8067 18.4891 18.6508 18.6437 18.4577C18.7926 18.2735 18.8988 18.0587 18.9547 17.8286C19.0106 17.5985 19.0148 17.3588 18.967 17.1269Z",
    fill: "#B2022F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconCart);
export default __webpack_public_path__ + "static/media/user_icon_cart.18b1ba5544268f4b3e3c0f4c191d2d79.svg";
export { ForwardRef as ReactComponent };